"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useESignProcess = void 0;
const react_1 = require("react");
const features_1 = require("../../features");
const initializer_1 = require("../../initializer");
const useESignProcessBase_hook_1 = require("./useESignProcessBase.hook");
const useESignProcess = () => {
    const interstitialsRepository = (0, react_1.useRef)(new features_1.InterstitialsRepository(initializer_1.API));
    return (0, useESignProcessBase_hook_1.useESignProcessBase)(interstitialsRepository.current);
};
exports.useESignProcess = useESignProcess;
//# sourceMappingURL=useESignProcess.hook.js.map